import React from 'react';
import axios from 'axios';
import Select from 'react-select';
import moment from 'moment';
import { CirclePicker } from "react-color"

// import SwipeableViews from 'react-swipeable-views';
// import Tabs from '@material-ui/core/Tabs';
// import Tab from '@material-ui/core/Tab';

moment.locale('ja')

import FullCalendar, { getDateMeta } from '@fullcalendar/react';
import timeGridPlugin from "@fullcalendar/timegrid";
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import resourceDayGridPlugin from '@fullcalendar/resource-daygrid';
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/timegrid/main.css";
import "@fullcalendar/timeline/main.css";


export default class CalendarMobile extends React.Component {

  constructor(props) {
    // Tabs.setUseDefaultStyles(false);
    super(props);
    this.state = {
      color: "",
      backgroundColor: "",
      borderColor: "",
      formInview: false,
      inputId: "",
      inputStart: "",
      inputStartTime: "",
      inputStartDate: "",
      inputEnd: "",
      inputEndTime: "",
      inputEndDate: "",

      oldStart: "",
      oldStartTime: "",
      oldStartDate: "",
      oldEnd: "",
      oldEndTime: "",
      oldEndDate: "",

      eventResource: "",
      resourceIds: [],
      // renderEvents: true,
      // renderItems: true,

      teamMemberList: "",
      memberList: "",
      isInputMemberList: false,

      inputDate: "",
      inputTitle: "",
      // inputFinished: false,
      inputMemo: "",
      // inputtoken: "",
      inputLink: "",
      isInputTitle: false,
      isChange: false,
      isResize: false,
      isDrag: false,
      modalIsOpen: false,

      user_id: "",
      user_name: "",
      team_id: "",
      temp_events: [],
      tempToken: "",
      textColor: "",
      allDay: false,

      price: "",

    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.ref = React.createRef();

    this.team_id = this.props.team_id;
    this.members = this.props.members;
    this.resources = this.props.resources;
    this.my = this.props.my;

    this.EVENT_SEL_NON = 0xffff;
    this.selEventID = this.EVENT_SEL_NON;
    this.onAddEvent = this.onAddEvent.bind(this);
    this.onChangeEvent = this.onChangeEvent.bind(this);
    this.onDeleteEvent = this.onDeleteEvent.bind(this);
    this.onClick = this.handleClick.bind(this);

    this.showEvents = this.showEvents.bind(this);
    this.showItems = this.showItems.bind(this);
    
    this.resetstate = this.resetstate.bind(this);
    // this.onSwatchHover = this.onSwatchHover.bind(this);
    this.onResizeCancel = this.onResizeCancel.bind(this);
    this.onDragCancel = this.onDragCancel.bind(this);
    this.onChangeResize = this.onChangeResize.bind(this);
    this.modalCancel = this.modalCancel.bind(this);
  }

  openModal() {
    this.setState({modalIsOpen: true});
    document.body.style.position = 'fixed';
    document.body.style.top = `-${window.scrollY}px`;
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
    this.setState({ allDay: false });
    // this.setState({tabindex: 0});
    document.body.style.position = '';
    document.body.style.top = '';
  }


  renderBaseModal() {
    return (
      <div>
        {/* {console.log(this.state.eventResource)} */}
        {this.state.eventResource === "items" ? (
          <div className={
            this.state.formInview
              ? "modal__container__form__items inview" 
              : "modal__container__form__items"
            }
          >{this.renderItemForm()}</div>
        ):(
          <div className={
            this.state.formInview
              ? "modal__container__form inview" 
              : "modal__container__form"
            }>{this.renderEventForm()}</div>
        )}
      </div>
    );
  }

  renderItemForm() {
    return (
      <div className="form__container">
        <div className="modal__sholder__buttons uk-flex uk-flex-right">
          <div className="modal_link_btn"><a href={process.env.ROOT_DIR+"items/"+this.state.inputId} target="_blank" rel="noopener noreferrer"><i className="fas fa-share"></i></a></div>
          <div className="modal_close_btn" onClick={() => {this.modalCancel()}}>X</div>
        </div>
          <h2 className="container__form__header uk-text-left">
            {this.state.inputTitle.length <= 10 ? (
              <span>{this.state.inputTitle}</span> ):(
              <span>{this.state.inputTitle.slice(0, 10)}...</span>
            )}
          </h2>
        <div className="uk-grid modal_scroll_form">
          <h4 className="uk-text-left">
            日時</h4>
          <div className="uk-width-1-1 uk-text-left">{this.state.inputStart}</div>
            
            <h4 className="uk-text-left">
              価格
            </h4>
            <div className="uk-width-1-1 uk-text-left">{this.state.price}円</div>
        
            <h4 className="uk-text-left">
              メモ</h4>
              
              <div className="uk-width-1-1 uk-text-left">{this.state.inputMemo}</div>

        <input
          className="container__form__btn_delete uk-width-1-2 form_buttons"
          // data-modal="close"
          type="button"
          value="OK"
          onClick={() => {this.modalCancel()}}
          // style={{background: this.state.color, color: '#fff', border: 'solid 0px' }}
        />
      </div>
    </div>

    )
  }

  renderEventForm() {
    // const { tabindex } = this.state;
    return (
      <div className="form__container">
        <div className="modal__sholder__buttons uk-flex uk-flex-right">
          <div className="modal_close_btn" onClick={() => {this.modalCancel()}}>X</div>
        </div>
        {this.state.isChange === false ? (
          <h2 className="container__form__header uk-text-left">新規スケジュール</h2>
          ) : (
          <h2 className="container__form__header uk-text-left">
            {this.state.inputTitle.length <= title_length_mobile ? (
              <span>{this.state.inputTitle}</span> ):(
              <span>{this.state.inputTitle.slice(0, title_length_mobile)}...</span>
            )}
          </h2>
        )}
        <div className="event_meta">{this.state.user_name}さん作成</div>
        <form>
          <div className="modal_scroll_form">
            <div className="form__height">
            {/* <Tabs value={tabindex}
                  centered 
                  onChange={this.handleChangeTab}
                  style={styles.tabs}
            >
              <Tab label="概要" />
              <Tab label="同日スケジュール" /> */}
              {/* <Tab label="関連タスク" /> */}
            {/* </Tabs> */}
            {/* <SwipeableViews
              index={tabindex}
              onChangeIndex={this.handleChangeIndex}
              disabled
              > */}
              {/* <div> */}
                <div>{this.renderTitle()}</div>
                <div className="uk-grid">
                  <div className="uk-width-1-2">
                    {this.renderAlldaySelect()}
                  </div>
                  <div className="uk-width-1-2">
                    {/* {this.renderDateSelect()} */}
                  </div>
                </div>
                <div>{this.renderStartTime()}</div>
                <div>{this.renderEndTime()}</div>
                <div>{this.renderMemo()}</div>
            </div>
            <div>
              {/* <div>{this.renderLink()}</div>  */}
              {this.team_id === 0 ? (<div></div>) : (
                <div>{this.renderTeamSelect()}</div>)}
              <div>{this.renderColor()}</div>
            </div>
          </div>
          {/* <div> */}
              {/* {this.renderSchedule()} */}
            {/* </div> */}
            {/* {this.renderTask()} */}
          {/* </SwipeableViewse> */}
          {/* </div> */}
        </form>
        <div className="modal__form__button">
          {this.renderBtn()}
        </div>
      </div>
    );
  }

  //--------------
  // フォーム関連
  //--------------

  renderAlldaySelect() {
    return(
      <div>
        <div className="switch_container uk-text-left">
        {this.state.allDay===true ? (
          <div className="switch_initial_container">
            <div className="allday_initial_true"></div>
            <div className="allday_initial_dot_true"></div>
          </div>
        ):(
          <div className="switch_initial_container">
             <div className="allday_initial"></div>
            <div className="allday_initial_dot"></div>
          </div>
        )}
          <div className="allday_switch">
            <input
              type="checkbox"
              id="c2"
              name="allDay"
              value={this.state.allDay}
              checked={this.state.allDay}
              onChange={(e) => {
                if (e.target.value === "false") {
                  this.setState({ allDay: true });
                } else {
                  this.setState({ allDay: false });
                }
                // console.log(e.target.value)
                // console.log(this.state.allday)
              }}
            />
            <label htmlFor="c2">
              終日
            </label>
          </div>
        </div>
      </div>
    )
  }

  renderTitle() {
    return (
      <React.Fragment>
        <div className="container__form__label uk-text-left">
          件名
        </div>
        <input
          className="container__form__input uk-input"
          type="text"
          value={this.state.inputTitle}
          onChange={(e) => {
            this.setState({ inputTitle: e.target.value });
            if (e.target.value === "") {
              this.setState({ isInputTitle: false });
            } else {
              this.setState({ isInputTitle: true });
            }
          }}
        />
      </React.Fragment>
    );
  }

  renderStartTime() {
    return (
      <React.Fragment>
        <div className="uk-grid time__container">
        <div className="uk-width-1-2">
          <div className="container__form__time__label uk-text-left">
            開始日
          </div>
          <div className="container__form__input">
            <input
              className="uk-input"
              type="date"
              format="YYYY-MM-DD"
              value={this.state.inputStartDate}
              onChange={(time) => {

                var startdate = time.target.value

                if(this.state.allDay){
                  this.setState({ inputStart: startdate +" 00:00" });
                }else{
                  this.setState({ inputStart: startdate +" "+ this.state.inputStartTime });
                }

                this.setState({ inputStartDate: startdate });

              }}
            />
          </div>
        </div>
        <div className="uk-width-1-2">
          <div className="container__form__time__label uk-text-left">
            開始日時
          </div>
          <div className="container__form__input">
            <input 
              className="uk-input"
              type="time"
              format="HH:mm"
              step='any'
              value={this.state.inputStartTime}
              disabled={this.state.allDay}
              onChange={(time) => {

                var starttime = time.target.value
                if(this.state.allDay){

                }else{
                  this.setState({ inputStart: this.state.inputStartDate +" "+ starttime }); 
                }
                this.setState({ inputStartTime: starttime });
              }}
            />
          </div>
        </div>
        </div>
      </React.Fragment>
    );
  }

  renderEndTime() {
    return (
      <React.Fragment>
        <div className="uk-grid time__container">
        <div className="uk-width-1-2">
        <div className="container__form__time__label uk-text-left">
          終了日時
        </div>
        <div className="container__form__input">
          <input 
            className="uk-input"
            type="date"
            format="YYYY-MM-DD"
            value={this.state.inputEndDate}
            // disabled={!this.state.period}
            onChange={(time) => {

              var enddate = time.target.value
              if(this.state.allDay){
                this.setState({ inputEnd: enddate +" 00:00" });
              }else{
                this.setState({ inputEnd: enddate +" "+ this.state.inputEndTime });
                
              }
              this.setState({ inputEndDate: enddate });
            }}
          />
          </div>
        </div>
        <div className="uk-width-1-2">
          <div className="container__form__time__label uk-text-left">
            終了日時
          </div>
          <div className="container__form__input">
          <input 
            className="uk-input"
            type="time"
            format="HH:mm"
            step='any'
            value={this.state.inputEndTime}
            disabled={this.state.allDay}
            onChange={(time) => {

              var endtime = time.target.value
              if(this.state.allDay){

              }else{
                this.setState({ inputEnd: this.state.inputEndDate +" "+ endtime });
              }
              this.setState({ inputEndTime: endtime });
            }}
          />
        </div>
        </div>
        </div>
      </React.Fragment>
    );
  }

  renderColor() {
    return (
      <div>
        <CirclePicker
          className="color_container uk-text-center"
          color={ this.state.backgroundColor }
          // width={'100%'}
          // onSwatchHover={this.onSwatchHover}
          onChangeComplete={
            (color) => {
              this.setState({ color: color.hex });
              this.setState({ backgroundColor: color.hex });
              this.setState({ borderColor: color.hex });
              this.setState({ textColor: eventTextColorSelect(this.state.color )});
            }
          }
        />
      </div>
    );
  }

  renderMemo() {
    return (
      <React.Fragment>
        <div className="container__form__label memo__container uk-text-left">
          内容
        </div>
        <textarea
          className="container__form__input uk-textarea form_controls"
          rows="4"
          value={this.state.inputMemo}
          onChange={(e) => {
            this.setState({ inputMemo: e.target.value });
          }}
        />
      </React.Fragment>
    );
  }

  renderTeamSelect() {
    return (
      <div className="teamselect___container">
        <div className="container__form__label  uk-text-left">
          関連メンバー
        </div>
        <Select
          className="uk-text-left"
          value={this.state.memberList}
          onChange={(e) =>{
            // console.log(e === void 0)
            // console.log(e)
            this.setState({ memberList: e});
            if (e === null) {
              this.setState({ isInputMemberList: false });
            } else {
              this.setState({ isInputMemberList: true });
            }
          }}
          options={this.state.teamMemberList}
          isMulti
          isSearchable
          placeholder={"共有するメンバーを選択"}
        />
      </div>
    );
  }

  renderBtn() {
    return (
      <div>
        {this.state.isChange === false ? (
          <div>
            <input
              className="container__form__btn_save form_buttons"
              type="button"
              value="保存"
              disabled={!this.state.isInputTitle || !this.state.isInputMemberList}
              onClick={this.onAddEvent}
            />
          </div>
        ) : (this.state.isResize === true ? (
          <div>
            <input
              className="container__form__btn_save uk-width-1-3 form_buttons"
              disabled={!this.state.isInputTitle || !this.state.isInputMemberList}
              type="button"
              value="変更を保存"
              onClick={this.onChangeEvent}
            />
            <input
              className="container__form__btn_delete uk-width-1-3 form_buttons"
              // data-modal="close"
              type="button"
              value="変更しない"
              onClick={this.onResizeCancel}
              // style={{background: this.state.color, color: '#fff', border: 'solid 0px' }}
            />
            <input
              className="container__form__btn_delete uk-width-1-3 form_buttons"
              // data-modal="close"
              type="button"
              value="削除"
              onClick={this.onDeleteEvent}
            />
          </div>
        ):(this.state.isDrag === true ? (
            <div>
              <input
                className="container__form__btn_save uk-width-1-3 form_buttons"
                disabled={!this.state.isInputTitle || !this.state.isInputMemberList}
                type="button"
                value="変更を保存"
                onClick={this.onChangeEvent}
              />
              <input
                className="container__form__btn_delete uk-width-1-3 form_buttons"
                // data-modal="close"
                type="button"
                value="変更しない"
                onClick={this.onResizeCancel}
              />
              <input
                className="container__form__btn_delete uk-width-1-3 form_buttons"
                // data-modal="close"
                type="button"
                value="削除"
                onClick={this.onDeleteEvent}
              />
            </div>
          ):(
            <div>
              <input
                className="container__form__btn_save uk-width-1-2 form_buttons"
                disabled={!this.state.isInputTitle || !this.state.isInputMemberList}
                type="button"
                value="変更"
                onClick={this.onChangeEvent}
              />
              <input
                className="container__form__btn_delete uk-width-1-2 form_buttons"
                // data-modal="close"
                type="button"
                value="削除"
                onClick={this.onDeleteEvent}
              />
            </div>
          )
        )
        )
        }
      </div>
    );
  }

  handleSelect = (selectInfo) => {
    selectInfo.jsEvent.preventDefault();
    // console.log(selectInfo)
    var startStr;
    var startDateStr;
    var startTimeStr;
    var endStr;
    var endDateStr;
    var endTimeStr;

    this.setState({ eventResource: "" });
    this.setState({ oldStart: "" });
    this.setState({ oldStartDate: "" });
    this.setState({ oldStartTime: "" });
    this.setState({ oldEnd: "" });
    this.setState({ oldEndTime: "" });
    this.setState({ oldEndDate: "" });
 
    if(selectInfo.start === undefined){
    }else{

      startStr = moment(selectInfo.start).format('YYYY-MM-DD HH:mm')
      startDateStr = moment(selectInfo.start).format('YYYY-MM-DD')
      startTimeStr = moment(selectInfo.start).format('HH:mm')

      this.setState({ inputStart: startStr });
      this.setState({ inputStartDate: startDateStr });
      this.setState({ inputStartTime: startTimeStr });
    }

    if(selectInfo.end === undefined){
    
    }else if(selectInfo.end === null){

      endStr = moment(selectInfo.start).format('YYYY-MM-DD HH:mm')
      endDateStr = moment(selectInfo.start).format('YYYY-MM-DD')
      endTimeStr = moment(selectInfo.start).format('HH:mm')

    }else{

      if(selectInfo.allDay === false){

        endStr = moment(selectInfo.end).format('YYYY-MM-DD HH:mm')
        endDateStr = moment(selectInfo.end).format('YYYY-MM-DD')
        endTimeStr = moment(selectInfo.end).format('HH:mm')

      }else{

        endStr = moment(selectInfo.end).add(-1,'days').startOf('day').format('YYYY-MM-DD HH:mm')
        endDateStr = moment(selectInfo.end).add(-1,'days').startOf('day').format('YYYY-MM-DD')
        endTimeStr = moment(selectInfo.end).add(-1,'days').startOf('day').format('HH:mm')

      }

      this.setState({ inputEnd: endStr });
      this.setState({ inputEndDate: endDateStr });
      this.setState({ inputEndTime: endTimeStr });

    }

      this.setState({ allDay: selectInfo.allDay });

      var ini_id;
      var ini_name;
      try{
        ini_id = selectInfo.resource._resource.id;
        ini_name = this.members.find(e => e.value === ini_id)
        ini_name = ini_name.label

      }catch(e){
        ini_id = this.my.id;
        ini_name = this.my.first_name + this.my.last_name;
      }

      var iniselect = {
        value: ini_id,
        label: ini_name,
      }

      this.setState({ resourceIds: ini_id }); 
      this.setState({ memberList: iniselect });
      this.setState({ teamMemberList: this.members });
      // this.setState({ resourceIds: [] }); 
      this.setState({ isInputMemberList: true });

      this.setState({ inputLink: "" });
      this.setState({ inputTitle: "" });
      this.setState({ inputMemo: "" });
      this.setState({ isInputTitle: false });
      this.setState({ isChange: false });
      this.setState({ isResize: false });
      this.setState({ isDrag: false });

      this.setState({ formInview: true });
      this.setState({ color: "" });
      this.setState({ backgroundColor: "" });
      this.setState({ borderColor: "" });
      this.setState({ textColor: "" });
      this.setState({ selectedTeamOption: "" }); 

      this.setState({ user_id: this.my.id });
      this.setState({ user_name: this.my.first_name + this.my.last_name });

  }

  handleClick = (info) => {
    info.jsEvent.preventDefault();
    // console.log(info.event);
   
    this.setState({ allDay: info.event.allDay });
  
    var startStr;
    var startDateStr;
    var startTimeStr;
    var endStr;
    var endDateStr;
    var endTimeStr;

    this.setState({ oldStart: "" });
    this.setState({ oldStartDate: "" });
    this.setState({ oldStartTime: "" });
    this.setState({ oldEnd: "" });
    this.setState({ oldEndTime: "" });
    this.setState({ oldEndDate: "" });

    if(info.event.start === undefined){
    }else{
      startStr = moment(info.event.start).format('YYYY-MM-DD HH:mm')
      startDateStr = moment(info.event.start).format('YYYY-MM-DD')
      startTimeStr = moment(info.event.start).format('HH:mm')
      this.setState({ inputStart: startStr });
      this.setState({ inputStartDate: startDateStr });
      this.setState({ inputStartTime: startTimeStr });
    }

    if(info.event.end === undefined){

    }else if(info.event.end === null){
      
      endStr = moment(info.event.start).format('YYYY-MM-DD HH:mm')
      endDateStr = moment(info.event.start).format('YYYY-MM-DD')
      endTimeStr = moment(info.event.start).format('HH:mm')

    }else{
      
      if(info.event.allDay === false){

        endStr = moment(info.event.end).format('YYYY-MM-DD HH:mm')
        endDateStr = moment(info.event.end).format('YYYY-MM-DD')
        endTimeStr = moment(info.event.end).format('HH:mm')

      }else{

        endStr = moment(info.event.end).add(-1,'days').format('YYYY-MM-DD HH:mm')
        endDateStr = moment(info.event.end).add(-1,'days').format('YYYY-MM-DD')
        endTimeStr = moment(info.event.end).add(-1,'days').format('HH:mm')

      }
    }

    this.setState({ inputEnd: endStr });
    this.setState({ inputEndDate: endDateStr });
    this.setState({ inputEndTime: endTimeStr });

    this.setState({ memberList: info.event.extendedProps.members });

    if (this.state.isInputMemberList === null) {
      this.setState({ isInputMemberList: false });
    } else {
      this.setState({ isInputMemberList: true });
    }

    this.setState({ teamMemberList: this.members });
    this.setState({ inputId: info.event._def.publicId });
    this.setState({ tempToken: info.event.extendedProps.temp_token });
    this.setState({ inputTitle: info.event.title });

    if(typeof info.event.extendedProps.memo !== null){
      this.setState({ inputMemo: info.event.extendedProps.memo });
    }else{
      this.setState({ inputMemo: "" });
    }
        
    if(typeof info.event.extendedProps.price !== null){
      this.setState({ price: info.event.extendedProps.price });
    }else{
      this.setState({ price: "" });
    }

    this.setState({ isInputTitle: true });
        
    const this_user_id = info.event.extendedProps.user_id;
    this.setState({ user_id: this_user_id });
    const targetUser = this.members.find((v) => v.value === this_user_id);
    // console.log(targetUser)
    if( targetUser === undefined){
      this.setState({ user_name: "未設定" });
    }else{
      this.setState({ user_name: targetUser["label"] });
    }

    this.setState({ isChange: true });
    this.setState({ isResize: false });
    this.setState({ isDrag: false });
    this.setState({ formInview: true });
    
    this.setState({ color: info.event.color });
    this.setState({ backgroundColor: info.event.backgroundColor });
    this.setState({ borderColor: info.event.borderColor });
    this.setState({ textColor: info.event.textColor });

    this.setState({ eventResource: info.event.extendedProps.resourcetype });

  }

  // componentDidMount(){
  //   const url = "http://localhost:3000/events/"+this.team_id+"/get_events";

  //   axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
  //   axios.get(url).then((res) => {
  //     console.info(res.data)
  //     this.setState({events: res.data});
  //   });  
  // }

  // handleMouseEnter = (mouseEnterInfo) => {
  //   console.log("handleMouseEnter")
  //   console.log(mouseEnterInfo)
  // }

  handleDrop = (eventDropInfo) => {

    eventDropInfo.jsEvent.preventDefault();

    this.setState({ allDay: eventDropInfo.event.allDay });

    var startStr;
    var startDateStr;
    var startTimeStr;
    var endStr;
    var endDateStr;
    var endTimeStr;
    
    var oldStartStr;
    var oldStartDateStr;
    var oldStartTimeStr;
    var oldEndStr;
    var oldEndDateStr;
    var oldEndTimeStr;

    // console.log(eventDropInfo.oldEvent.start)
    // console.log(eventDropInfo.oldEvent.end)
    // console.log(eventDropInfo.event.start)
    // console.log(eventDropInfo.event.end)

    if(eventDropInfo.event.start === undefined){
    }else{
      startStr = moment(eventDropInfo.event.start).format('YYYY-MM-DD HH:mm')
      startDateStr = moment(eventDropInfo.event.start).format('YYYY-MM-DD')
      startTimeStr = moment(eventDropInfo.event.start).format('HH:mm')
      this.setState({ inputStart: startStr });
      this.setState({ inputStartDate: startDateStr });
      this.setState({ inputStartTime: startTimeStr });

      oldStartStr = moment(eventDropInfo.oldEvent.start).format('YYYY-MM-DD HH:mm')
      oldStartDateStr = moment(eventDropInfo.oldEvent.start).format('YYYY-MM-DD')
      oldStartTimeStr = moment(eventDropInfo.oldEvent.start).format('HH:mm')
      this.setState({ oldStart: oldStartStr });
      this.setState({ oldStartDate: oldStartDateStr });
      this.setState({ oldStartTime: oldStartTimeStr });

    }

    if(eventDropInfo.event.end === undefined){

    }else if(eventDropInfo.event.end === null){
      
      endStr = moment(eventDropInfo.event.start).format('YYYY-MM-DD HH:mm')
      endDateStr = moment(eventDropInfo.event.start).format('YYYY-MM-DD')
      endTimeStr = moment(eventDropInfo.event.start).format('HH:mm')

      oldEndStr = moment(eventDropInfo.oldEvent.start).format('YYYY-MM-DD HH:mm')
      oldEndDateStr = moment(eventDropInfo.oldEvent.start).format('YYYY-MM-DD')
      oldEndTimeStr = moment(eventDropInfo.oldEvent.start).format('HH:mm')

    }else{
      
      if(eventDropInfo.event.allDay === false){

        endStr = moment(eventDropInfo.event.end).format('YYYY-MM-DD HH:mm')
        endDateStr = moment(eventDropInfo.event.end).format('YYYY-MM-DD')
        endTimeStr = moment(eventDropInfo.event.end).format('HH:mm')

        oldEndStr = moment(eventDropInfo.oldEvent.end).format('YYYY-MM-DD HH:mm')
        oldEndDateStr = moment(eventDropInfo.oldEvent.end).format('YYYY-MM-DD')
        oldEndTimeStr = moment(eventDropInfo.oldEvent.end).format('HH:mm')

      }else{

        endStr = moment(eventDropInfo.event.end).add(-1,'days').format('YYYY-MM-DD HH:mm')
        endDateStr = moment(eventDropInfo.event.end).add(-1,'days').format('YYYY-MM-DD')
        endTimeStr = moment(eventDropInfo.event.end).add(-1,'days').format('HH:mm')

        oldEndStr = moment(eventDropInfo.oldEvent.end).add(-1,'days').format('YYYY-MM-DD HH:mm')
        oldEndDateStr = moment(eventDropInfo.oldEvent.end).add(-1,'days').format('YYYY-MM-DD')
        oldEndTimeStr = moment(eventDropInfo.oldEvent.end).add(-1,'days').format('HH:mm')

      }
    }

    this.setState({ inputEnd: endStr });
    this.setState({ inputEndDate: endDateStr });
    this.setState({ inputEndTime: endTimeStr });
    
    this.setState({ oldEnd: oldEndStr });
    this.setState({ oldEndTime: oldEndDateStr });
    this.setState({ oldEndDate: oldEndTimeStr });

    this.setState({ memberList: eventDropInfo.event.extendedProps.members });

    this.setState({ isInputMemberList: true });

    this.setState({ teamMemberList: this.members });

    this.setState({ inputId: eventDropInfo.event._def.publicId });
    this.setState({ tempToken: eventDropInfo.event.extendedProps.temp_token });
    this.setState({ inputTitle: eventDropInfo.event.title });
    
    if(typeof eventDropInfo.event.extendedProps.memo !== null){
      this.setState({ inputMemo: eventDropInfo.event.extendedProps.memo });
    }else{
      this.setState({ inputMemo: "" });
    }

    this.setState({ isInputTitle: true });
    
    const this_user_id = eventDropInfo.event.extendedProps.user_id;
    this.setState({ user_id: this_user_id });
    const targetUser = this.members.find((v) => v.value === this_user_id);

    if( targetUser === undefined){
      this.setState({ user_name: "未設定" });
    }else{
      this.setState({ user_name: targetUser["label"] });
    }

    this.setState({ isChange: true });
    this.setState({ isResize: false });
    this.setState({ isDrag: false });

    this.setState({ isDrag: true });

    this.setState({ formInview: true });

    this.setState({ color: eventDropInfo.event.color });
    this.setState({ backgroundColor: eventDropInfo.event.backgroundColor });
    this.setState({ borderColor: eventDropInfo.event.borderColor });
    this.setState({ textColor: eventDropInfo.event.textColor });
    
  }


  handleResize = (eventResizeInfo) => {
    this.setState({ allDay: eventResizeInfo.event.allDay });

    var startStr;
    var startDateStr;
    var startTimeStr;
    var endStr;
    var endDateStr;
    var endTimeStr;
    
    var oldStartStr;
    var oldStartDateStr;
    var oldStartTimeStr;
    var oldEndStr;
    var oldEndDateStr;
    var oldEndTimeStr;

    // console.log(eventResizeInfo.oldEvent.start)
    // console.log(eventResizeInfo.oldEvent.end)
    // console.log(eventResizeInfo.event.start)
    // console.log(eventResizeInfo.event.end)

    if(eventResizeInfo.event.start === undefined){
    }else{
      startStr = moment(eventResizeInfo.event.start).format('YYYY-MM-DD HH:mm')
      startDateStr = moment(eventResizeInfo.event.start).format('YYYY-MM-DD')
      startTimeStr = moment(eventResizeInfo.event.start).format('HH:mm')
      this.setState({ inputStart: startStr });
      this.setState({ inputStartDate: startDateStr });
      this.setState({ inputStartTime: startTimeStr });

      oldStartStr = moment(eventResizeInfo.oldEvent.start).format('YYYY-MM-DD HH:mm')
      oldStartDateStr = moment(eventResizeInfo.oldEvent.start).format('YYYY-MM-DD')
      oldStartTimeStr = moment(eventResizeInfo.oldEvent.start).format('HH:mm')
      this.setState({ oldStart: oldStartStr });
      this.setState({ oldStartDate: oldStartDateStr });
      this.setState({ oldStartTime: oldStartTimeStr });

    }

    if(eventResizeInfo.event.end === undefined){

    }else if(eventResizeInfo.event.end === null){
      
      endStr = moment(eventResizeInfo.event.start).format('YYYY-MM-DD HH:mm')
      endDateStr = moment(eventResizeInfo.event.start).format('YYYY-MM-DD')
      endTimeStr = moment(eventResizeInfo.event.start).format('HH:mm')

      oldEndStr = moment(eventResizeInfo.oldEvent.start).format('YYYY-MM-DD HH:mm')
      oldEndDateStr = moment(eventResizeInfo.oldEvent.start).format('YYYY-MM-DD')
      oldEndTimeStr = moment(eventResizeInfo.oldEvent.start).format('HH:mm')

    }else{
      
      if(eventResizeInfo.event.allDay === false){

        endStr = moment(eventResizeInfo.event.end).format('YYYY-MM-DD HH:mm')
        endDateStr = moment(eventResizeInfo.event.end).format('YYYY-MM-DD')
        endTimeStr = moment(eventResizeInfo.event.end).format('HH:mm')

        oldEndStr = moment(eventResizeInfo.oldEvent.end).format('YYYY-MM-DD HH:mm')
        oldEndDateStr = moment(eventResizeInfo.oldEvent.end).format('YYYY-MM-DD')
        oldEndTimeStr = moment(eventResizeInfo.oldEvent.end).format('HH:mm')

      }else{

        endStr = moment(eventResizeInfo.event.end).add(-1,'days').format('YYYY-MM-DD HH:mm')
        endDateStr = moment(eventResizeInfo.event.end).add(-1,'days').format('YYYY-MM-DD')
        endTimeStr = moment(eventResizeInfo.event.end).add(-1,'days').format('HH:mm')

        oldEndStr = moment(eventResizeInfo.oldEvent.end).add(-1,'days').format('YYYY-MM-DD HH:mm')
        oldEndDateStr = moment(eventResizeInfo.oldEvent.end).add(-1,'days').format('YYYY-MM-DD')
        oldEndTimeStr = moment(eventResizeInfo.oldEvent.end).add(-1,'days').format('HH:mm')
      }
    }

    this.setState({ inputEnd: endStr });
    this.setState({ inputEndDate: endDateStr });
    this.setState({ inputEndTime: endTimeStr });
    
    this.setState({ oldEnd: oldEndStr });
    this.setState({ oldEndTime: oldEndDateStr });
    this.setState({ oldEndDate: oldEndTimeStr });

    this.setState({ memberList: eventResizeInfo.event.extendedProps.members });
    this.setState({ isInputMemberList: false });
    this.setState({ teamMemberList: this.members });

    this.setState({ inputId: eventResizeInfo.event._def.publicId });
    this.setState({ tempToken: eventResizeInfo.event.extendedProps.temp_token });
    this.setState({ inputTitle: eventResizeInfo.event.title });
    if(typeof eventResizeInfo.event.extendedProps.memo !== null){
      this.setState({ inputMemo: eventResizeInfo.event.extendedProps.memo });
    }else{
      this.setState({ inputMemo: "" });
    }


    const this_user_id = eventResizeInfo.event.extendedProps.user_id;
    this.setState({ user_id: this_user_id });
    const targetUser = this.members.find((v) => v.value === this_user_id);
    // console.log(targetUser)
    if( targetUser === undefined){
      this.setState({ user_name: "未設定" });
    }else{
      this.setState({ user_name: targetUser["label"] });
    }
    
    this.setState({ isInputTitle: true });
    
    this.setState({ isChange: true });
    this.setState({ isResize: true });
    this.setState({ isDrag: false });

    this.setState({ formInview: true });

    this.setState({ color: eventResizeInfo.event.color });
    this.setState({ backgroundColor: eventResizeInfo.event.backgroundColor });
    this.setState({ borderColor: eventResizeInfo.event.borderColor });
    this.setState({ textColor: eventResizeInfo.event.textColor });

    try{
      // console.log(info.event._def.resourceIds.toString().split(','));
      this.setState({ resourceIds: eventResizeInfo.event._def.resourceIds.toString().split(',') });
    }catch(e){
      // console.log(e);
      // console.log(info.event._def.resourceIds);
      this.setState({ resourceIds: eventResizeInfo.event._def.resourceIds.toString() });
    }

    eventResizeInfo.jsEvent.preventDefault();
  }

  onChangeResize = (eventResizeInfo) => {
  //   // console.log(eventResizeInfo)
  }

  onResizeCancel = () => {
    
    if (window.confirm("変更をキャンセルしますか？")) {

      var starttime = this.state.oldStart;
      var endtime = this.state.oldEnd;
      var datetime;

      // if (starttime > endtime) {
      //   alert("開始時間と終了時間を確認してください。");
      //   return;
      // }else{

        // this.setState({loading: true})
       
        // console.log(this.state.color)
        // console.log(this.state.backgroundColor)
        // console.log(this.state.borderColor)
        
        // var color;
        // var text_color;
        // this.state.backgroundColor.length !== 7 ?
        // (color = '#607d8b', text_color= "#ffffff"):
        // (color = this.state.backgroundColor, text_color = this.state.textColor);
        
        // console.log(color)

        if (this.state.allDay === true){
          if(this.state.oldStartDate === this.state.oldEndDate){
            datetime = this.state.oldStartDate;
            starttime = null
            endtime = null
          }else{
  
          }
        }else{
          datetime = null
        }

        var selected_event;
        var events = this.ref.current.getApi().getEvents()

        if (this.state.inputId !== ""){
          selected_event = events.find(ev => ev._def.publicId === this.state.inputId)
          // console.log(selected_event)
        }else{
          selected_event = events.find(ev => ev.extendedProps.temp_token === this.state.tempToken)
          // console.log(selected_event)
        }

        var resourceMembers;

        // console.log(this.state.memberList)
        if(this.state.memberList.length === void 0){
          resourceMembers = [this.state.memberList.value];
        }else{
          try{
            resourceMembers = this.state.memberList.map((jsn) => {
              return jsn.value
            });
          }catch(e){
            resourceMembers = [];
          }
        }

        // console.log(selected_event)
        const new_event = {
          temp_token: selected_event.extendedProps.temp_token,
          title: selected_event.title,
          memo: selected_event.extendedProps.memo,
          start: starttime,
          end: endtime,
          date: datetime,
          team_id: this.team_id,
          allDay: selected_event.allDay,
          color: selected_event.backgroundColor,
          textColor: selected_event.textColor,
          members: selected_event.extendedProps.members,
          resourceIds: resourceMembers,
          editable: true,
          user_id: this.state.user_id
        };

        // console.log(new_event)
        // console.log(selected_event)

        selected_event.remove();
        const delevents = this.state.temp_events.filter(ev => {
            return ev.temp_token !== selected_event.extendedProps.temp_token
        })
        delevents.push(new_event);

        this.ref.current.getApi().addEvent(new_event);
          
        // console.log(this.state.events);
        // console.log(this.state.temp_events);

        this.setState({temp_events: delevents});
        this.setState({ loading: false });

        this.setState({ oldStart: "" });
        this.setState({ oldStartDate: "" });
        this.setState({ oldStartTime: "" });
        this.setState({ oldEnd: "" });
        this.setState({ oldEndTime: "" });
        this.setState({ oldEndDate: "" });

        this.setState({ isResize: false });
        this.setState({ isDrag: false });
        
        this.resetstate();

    }
  }

  onDragCancel = () => {
    
    if (window.confirm("変更をキャンセルしますか？")) {

      var starttime = this.state.oldStart;
      var endtime = this.state.oldEnd;
      var datetime;

      // if (starttime > endtime) {
      //   alert("開始時間と終了時間を確認してください。");
      //   return;
      // }else{

        this.setState({loading: true})
        if (this.state.allDay === true){
          if(this.state.oldStartDate === this.state.oldEndDate){
            datetime = this.state.oldStartDate;
            starttime = null
            endtime = null
          }else{
  
          }
        }else{
          datetime = null
        }

        var selected_event;
        var events = this.ref.current.getApi().getEvents()

        if (this.state.inputId !== ""){
          selected_event = events.find(ev => ev._def.publicId === this.state.inputId)
          // console.log(selected_event)
        }else{
          selected_event = events.find(ev => ev.extendedProps.temp_token === this.state.tempToken)
          // console.log(selected_event)
        }

        var resourceMember;

        try{
          resourceMember = this.state.memberList.map((jsn) => jsn.value);
        }catch(e){
          resourceMember = [];
        }

        // console.log(resourceMember)

        const new_event = {
          temp_token: selected_event.extendedProps.temp_token,
          title: selected_event.title,
          memo: selected_event.extendedProps.memo,
          start: starttime,
          end: endtime,
          date: datetime,
          team_id: this.team_id,
          allDay: selected_event.allDay,
          color: selected_event.backgroundColor,
          textColor: selected_event.textColor,
          members: selected_event.extendedProps.members,
          resourceIds: resourceMembers,
          editable: true,
          user_id: this.state.user_id
        };

        selected_event.remove();
        const delevents = this.state.temp_events.filter(ev => {
            return ev.temp_token !== selected_event.extendedProps.temp_token
        })
        delevents.push(new_event);

        this.ref.current.getApi().addEvent(new_event);

        this.setState({temp_events: delevents});
        this.setState({ loading: false });

        
        this.setState({ oldStart: "" });
        this.setState({ oldStartDate: "" });
        this.setState({ oldStartTime: "" });
        this.setState({ oldEnd: "" });
        this.setState({ oldEndTime: "" });
        this.setState({ oldEndDate: "" });

        this.setState({ isResize: false });
        this.setState({ isDrag: false });

        this.resetstate();

    }
  }

  modalCancel = () =>{
    if(!this.state.isChange){
      if (window.confirm("作成ををキャンセルしますか？")) {
        this.resetstate()
      }
    }else if(this.state.isResize){
      this.onResizeCancel()
    }else if(this.state.isDrag){
      this.onDragCancel()
    }else{
      // if (window.confirm("変更をキャンセルしますか？")) {
        this.resetstate()
      // }
    }
  }

  showEvents = (fetchInfo, successCallback) =>{
    // if(this.state.renderEvents){
      get_eventdata(fetchInfo, this.team_id)
      .then((returnEvents) => {
        var filtered_events = returnEvents.events;
        this.state.temp_events.forEach(item => {
          filtered_events = filtered_events.filter(ev => ev.temp_token !== item.temp_token)
        });

        const member_list = returnEvents.members
        this.setState({members: member_list})

        successCallback(filtered_events);
        // console.log(filtered_events)
        
      })
      .catch((error) => {
        // console.log(error);
      })
    // }
  }

  render(
    
  ) {
    return (
      <div>
        {this.renderCover()}
        {this.renderBaseModal()}          
        <div className="calendar_container">
          <FullCalendar
          locale={'ja'}
          plugins={[dayGridPlugin,
            timeGridPlugin,
            interactionPlugin,
            listPlugin,
            resourceDayGridPlugin,
            resourceTimelinePlugin]}
          ref={this.ref}
          weekends={true} // 週末表示
          eventClick={this.handleClick}
          selectable={true} // 日付選択可能
          allDaySlot={true}
          allDayText={'終日'}
          slotDuration={"00:30:00"}
          aspectRatio={1.2}
          firstDay={1}
          forceEventDuration={true}
          selectMirror={true}
          unselectAuto={true}
          // expandRows
          contentHeight={650}
          navLinks={true}
          expandRows={true}
          // EventPopover
          dayMaxEventRows={true, 4}
          dayMaxEvents={true, 4}
          // nowIndicator={true}
          // eventContent={renderEventContent}
          // dateClick={this.handleSelect}
          select={this.handleSelect} // カレンダー範囲選択時
          eventMouseEnter={this.handleMouseEnter}
          eventDrop={this.handleDrop}
          eventResize={this.handleResize}
          headerToolbar={toolbar}
          views={fordayview}
          initialView={"resourceTimeLine"}
          // footerToolbar={footertoolbar}
          themeSystem={'standard'}
          businessHours={busyhour}
          selectLongPressDelay={300}
          longPressDelay={10}
          eventLongPressDelay={10}
          contentHeight={"auto"}
          // scrollTime={'06:00'}
          slotMinTime={mintime}
          slotMaxTime={maxtime}
          schedulerLicenseKey={process.env.LKEY}
          droppable={false}
          editable={false}
          eventResourceEditable={true}
          // events={this.showEvents}
          // eventsSet={this.state.events}
          eventSources={[this.showEvents, this.showItems]}
          resources={this.resources}
          resourceAreaWidth={'30%'}
          />
      </div>
      {/* {this.renderEventsSwitch()}
      {this.renderItemsSwitch()} */}
    </div>
    )
  }
  
  //--------------
  // カバー関連
  //--------------
  renderCover() {
    // console.log(paramevents)
    return (
      <div
        // onClick={() => {
        //   this.setState({ formInview: false });
        //   this.setState({ allDay: false });
        // }}
        className={
          this.state.formInview
          ? "container__cover inview"
          : "container__cover "
        }
    ></div>
    );
  }

  //--------------
  // イベント関連
  //--------------

  onAddEvent() {
    
    var starttime = this.state.inputStart;
    var endtime = this.state.inputEnd;
    var datetime;

    if (starttime > endtime) {
      alert("開始時間と終了時間を確認してください。");
      return;
    }else{

      var color;
      var text_color;
      this.state.color.length !== 7 ?
       (color = '#607d8b', text_color= "#ffffff"):
       (color = this.state.color, text_color = this.state.textColor);

      if (this.state.allDay === true){
        if(this.state.inputStartDate === this.state.inputEndDate){
          datetime = this.state.inputStartDate;
          starttime = null
          endtime = null
        }else{

        }
      }else{
        datetime = null
      }

      var resourceMembers;

      if(this.state.memberList.length === void 0){
        resourceMembers = [this.state.memberList.value];
      }else{
        try{
          resourceMembers = this.state.memberList.map((jsn) => {
            return jsn.value
          });
        }catch(e){
          resourceMembers = [];
        }
      }
      
      const new_event = {
        temp_token: getRandomStr(),
        title: this.state.inputTitle,
        memo: this.state.inputMemo,
        start: starttime,
        end: endtime,
        date: datetime,
        team_id: this.team_id,
        allDay: this.state.allDay,
        color: color,
        textColor: text_color,
        members: this.state.memberList,
        resourceIds: resourceMembers,
        editable: true,
        user_id: this.my.id
      };

      if (this.addEvent(new_event, this.team_id)){
        this.setState({loading: true})
        if(post_eventdata(new_event, this.team_id)){
          this.setState({loading: false})
          this.resetstate()
        }
      }
    }
  }

  addEvent = (event, col) => {
    // event.id = this.getID();
    this.ref.current.getApi().addEvent(event);
    // console.log(event)
    // console.log(this.ref.current.getApi().getEvents())
    this.state.temp_events.push(event);
    // console.log(this.state.events)
    // console.log(this.state.temp_events)
    return true;
  };

  onChangeEvent() {

    if (window.confirm("変更しますか？")) {

      var starttime = this.state.inputStart;
      var endtime = this.state.inputEnd;
      var datetime;

      if (starttime > endtime) {
        alert("開始時間と終了時間を確認してください。");
        return;
      }else{

        this.setState({loading: true})
        
        // console.log(this.state.color)
        // console.log(this.state.backgroundColor)
        // console.log(this.state.borderColor)
        
        var color;
        var text_color;
        this.state.backgroundColor.length !== 7 ?
        (color = '#607d8b', text_color= "#ffffff"):
        (color = this.state.backgroundColor, text_color = this.state.textColor);
        
        // console.log(color)

        if (this.state.allDay === true){
          if(this.state.inputStartDate === this.state.inputEndDate){
            datetime = this.state.inputStartDate;
            starttime = null
            endtime = null
          }else{
  
          }
        }else{
          datetime = null
        }

        var selected_event;
        var events = this.ref.current.getApi().getEvents()

        if (this.state.inputId !== ""){
          selected_event = events.find(ev => ev._def.publicId === this.state.inputId)
          // console.log(selected_event)
        }else{
          selected_event = events.find(ev => ev.extendedProps.temp_token === this.state.tempToken)
          // console.log(selected_event)
        }

        var resourceMembers;
        if(this.state.memberList.length === void 0){
          resourceMembers = [this.state.memberList.value];
        }else{
          try{
            resourceMembers = this.state.memberList.map((jsn) => {
              return jsn.value
            });
          }catch(e){
            resourceMembers = [];
          }
        }

        const new_event = {
          temp_token: this.state.tempToken,
          title: this.state.inputTitle,
          memo: this.state.inputMemo,
          start: starttime,
          end: endtime,
          date: datetime,
          team_id: this.team_id,
          allDay: this.state.allDay,
          color: color,
          editable: true,
          textColor: text_color,
          members: this.state.memberList,
          resourceIds: resourceMembers,
          user_id: this.my.id
        };

        if (update_eventdata(new_event, this.team_id)){
          selected_event.remove();
          const delevents = this.state.temp_events.filter(ev => {
              return ev.temp_token !== this.state.tempToken
          })
          delevents.push(new_event);
          // console.log(new_event)
          this.ref.current.getApi().addEvent(new_event);
        
          this.setState({temp_events: delevents});
          this.setState({ loading: false });
          this.resetstate();
        }
      }
    }
  }

  changeEvent = (new_event, old_event, col) => {
    old_event.remove();
    this.ref.current.getApi().addEvent(new_event);
    
    this.state.temp_events.push(new_event);

    return true;
  };

  onDeleteEvent() {

    if (window.confirm("削除しますか？")) {
      this.setState({loading: true})
      var selected_event;
      var events = this.ref.current.getApi().getEvents();

      if (this.state.inputId !== ""){
        selected_event = events.find(ev => ev._def.publicId === this.state.inputId)
        // console.log(selected_event)
      }else{
        selected_event = events.find(ev => ev.extendedProps.temp_token === this.state.tempToken)
        // console.log(selected_event)
      }
      // console.log(selected_event)  

      if (delete_eventdata(selected_event, this.team_id)){
        // console.log(selected_event)  
        selected_event.remove()
        this.setState({loading: false})

        this.resetstate()

        const delevents = this.state.temp_events.filter(ev => {
          return ev.temp_token !== this.state.tempToken
        })
        // console.log(delevents)
        this.setState({temp_events: delevents})
        // console.log(events)
      }
    }
  }

  showItems = (fetchInfo, successCallback) =>{
    // if(this.state.renderItems){
      get_itemdata(fetchInfo, this.team_id)
        .then((returnItems) => {
          const filtered_items = returnItems.items;

          // this.state.temp_items.forEach(item => {
          //   filtered_events = filtered_items.filter(it => it.temp_token !== item.temp_token)
          // });

          successCallback(filtered_items);
          // console.log(filtered_items)
        })
        .catch((error) => {
          // console.log(error);
        }
      )
    // }
  }
  
  resetstate = () =>{

    this.setState({ formInview: false });
    this.setState({ allDay: false });
    this.setState({ backgroundColor: "" });
    this.setState({ borderColor: "" });
  }

}

const toolbar = {
  left: "dayGridMonth,resourceTimeLine,listWeek",
  center: "title",
  right: "prev,next"
}

const modalStyles = {
  overlay: {
    zIndex: 9999,
    background: 'rgba(0,0,0, .4)'
  },

  content : {
    'padding': '20px',
    'width': '480px',
    'height': '640px',
    'margin': '10% auto'
  }
};

const busyhour = {
  daysOfWeek: [1, 2, 3, 4, 5],
  startTime: "0:00",
  endTime: "24:00",
}

const customControlStyles = base => ({
  height: 50,
});

const styles = {
  tabs: {
    background: '#fff',
    border: 'solid 1px #fff',
    margin: '10px 0 0 0'
  }
};

const title_length_mobile = 8
const title_length_destop = 20

const mintime = "00:00"
const maxtime = "24:00"

const fordayview = {      
  dayGridMonth:{
    buttonText: '月',
    titleFormat: { year: 'numeric', month: 'long' },
  },
  // timeGridWeek:{
  //   buttonText: '日',
  //   titleFormat: { year: 'numeric', month: 'long' },
  // },
  // dayGridWeek:{
  //   buttonText: '週',
  //   titleFormat: { year: 'numeric',month: 'long', day: 'numeric'},
  // },
    // listDayFormat: { month: 'numeric', day: 'numeric', weekday: 'narrow' }
  resourceTimeLine:{
    resourceAreaHeaderContent: 'メンバー',
    buttonText: '日',
    type: 'resourceTimeline',
    titleFormat: { year: 'numeric', month: 'long' },
    resources: [
    ],
    titleFormat: { year: 'numeric', month: 'long', day: 'numeric',  weekday: 'long'},
  },
  listWeek:{
    buttonText: 'リスト',
    titleFormat: { year: 'numeric',month: 'long', day: 'numeric'},
    type: 'listWeek'
  }
}  

function get_eventdata(fetchInfo, ids){
  const queries = {
    start: fetchInfo.start,
    end: fetchInfo.end,
    mobile: true
  }

  const url = process.env.ROOT_DIR+"events/"+ids+"/get_events"
  axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
  return axios.get(url, 
    {params: queries},
    ).then((response) => {
      // console.log(response.data)
      return response.data;
    }).catch(error => {
      // console.info(error)
      return error
    }
  )
}

function post_eventdata(event, ids){
  // console.log(event)
  const url = process.env.ROOT_DIR+"events/"+ids+"/create" 
  return axios.post(url, 
    {event: event},
    {headers: {'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')}}
    ).then(() => {
      return true
  }).catch(error => {
    // console.info(error)
    return error
  })
 
}

function update_eventdata(event, ids){
  
  const url = process.env.ROOT_DIR + "events/" + ids + "/update"
       
  return axios.post(url,
    {event: event},
    {headers: {'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')}}).then(() => {
    return true
  }).catch(error => {
    // console.info(error)
    return error
  })
}

function delete_eventdata(event, ids){
  const url = process.env.ROOT_DIR+"events/"+ids+"/destroy"
         
  return axios.post(url,
    {event: event},
    {headers: {'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')}}).then(() => {
    return true
  }).catch(error => {
    // console.info(error)
    return error
  })
}

function get_itemdata(fetchInfo, ids){
  const queries = {
    start: fetchInfo.start,
    end: fetchInfo.end
  }

  const url = process.env.ROOT_DIR+"items/"+ids+"/get_items"
  
  // console.log(url)
  axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
  return axios.get(url, 
    {params: queries},
    ).then((response) => {
      // console.log(response)
      return response.data;
    }).catch(error => {
      // console.info(error)
      return error
    }
  )
}

function eventTextColorSelect(color){
  var colorSet = ["#8bc34a", "#ffeb3b", "#cddc39", "#ffc107"]
  var eventTextColor;
  {colorSet.some(item => item === color) ? (
    eventTextColor = "#000000"
  ):(
    eventTextColor = "#ffffff"
  )}
  return eventTextColor
}

function getRandomStr(){
  const LENGTH = 20
  const SOURCE = "abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
  let result = ''

  for(let i=0; i<LENGTH; i++){
    result += SOURCE[Math.floor(Math.random() * SOURCE.length)];
  }
  
  return result
}
